import React from 'react';

import { ReactComponent as CustomerSatisfactionSVG } from '../../assets/icons/customer-satidfaction.svg';
import { ReactComponent as EfficiencySVG } from '../../assets/icons/efficiency.svg';
import { ReactComponent as ExpertiseSVG } from '../../assets/icons/expertise.svg';
import { ReactComponent as InnovationSVG } from '../../assets/icons/innovation.svg';
import { Typography } from '../../designComponents';
import { WhyChooseUsCardStyled, WhyChooseUsStyled } from './landing-styles';

interface StrategicCardProps {
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
  description: string;
  title: string;
}

const StrategicCard: React.FC<StrategicCardProps> = ({
  icon: Icon,
  description,
  title,
}) => {
  return (
    <WhyChooseUsCardStyled>
      <Icon className="icon" />
      <Typography className="title">{title}</Typography>
      <Typography className="desc">{description}</Typography>
    </WhyChooseUsCardStyled>
  );
};

const WhyChooseUs = () => {
  return (
    <WhyChooseUsStyled>
      <div className="info-container">
        <Typography className="info-header" strong>
          Why Choose Us?
        </Typography>
        <Typography className="info-desc">
          Choose EscapePlan for unparalleled expertise, efficiency, and quality
          assurance. With a commitment to customer satisfaction, innovation, and
          transparent pricing, we're your trusted partner.
        </Typography>
      </div>

      <div className="card-grid-container">
        <StrategicCard
          description="Our team of skilled CAD technicians specializes in fire escape planning, with years of experience in the industry. Trust us to deliver accurate and compliant blueprints tailored to your building's needs."
          title="Expertise"
          icon={ExpertiseSVG}
        />
        <StrategicCard
          description="We understand the importance of timely delivery, which is why we streamline the blueprint creation process to ensure prompt and efficient service. Count on us to meet your deadlines without compromising on quality."
          title="Efficiency"
          icon={EfficiencySVG}
        />
        <StrategicCard
          description="We prioritize customer satisfaction and strive to exceed your expectations with every project. Our dedicated team is committed to providing exceptional service and support for you."
          title="Customer Satisfaction"
          icon={CustomerSatisfactionSVG}
        />
        <StrategicCard
          description="We stay up-to-date with the latest advancements in CAD technology and fire safety standards to deliver cutting-edge solutions to our clients. Benefit from our innovative approach to fire escape planning."
          title="Innovation"
          icon={InnovationSVG}
        />
      </div>
    </WhyChooseUsStyled>
  );
};

export default WhyChooseUs;
